import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'validation-icon',
    styleUrls: ['../../base/base-form-kit.scss'],
    imports: [
        CommonModule,
        MatTooltipModule,
        TranslateModule
    ],
    templateUrl: './validation-icon.component.html'
})
export class ValidationIconComponent {

  @Input() hasMatPrefix: boolean = false;
  @Input() hasMatSuffix: boolean = false;
  @Input() value: any;
  @Input() isLtr: boolean = false;
  @Input() control: FormControl | any;
  @Input() isShowValidationStatusIcon: boolean = true;


}
